// ScaleLabel > ScaleLabel
import React from 'react'
import styled from 'styled-components'
import { ScaleLabelProps } from './index'

const ScaleLabelTypography = styled.p`margin: 0px;`

const ScaleLabel: React.SFC<ScaleLabelProps> = ({ className, children }) => {
	return (
		<div className={className}>
			<ScaleLabelTypography>{children}</ScaleLabelTypography>
		</div>
	)
}

export default styled(ScaleLabel)`
	height: calc(${({ numLabels, labelFrequency }) => `${labelFrequency / numLabels * 100}%`} + 0.3333px);
	text-align: right;
`
